import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetDashboardActivities200,
  GetDashboardActivitiesParams,
  GetDashboardPaymentMethods200,
  GetDashboardStatistics200,
  GetDashboardStatisticsParams,
  GetDashboardSummary200
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary 대시보드 활동 내역 조회
 */
export const getDashboardActivities = (
    params?: GetDashboardActivitiesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetDashboardActivities200>(
      {url: `/api/v1/dashboard/activities`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetDashboardActivitiesQueryKey = (params?: GetDashboardActivitiesParams,) => {
    return [`/api/v1/dashboard/activities`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDashboardActivitiesInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardActivities>>, TError = unknown>(params?: GetDashboardActivitiesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardActivities>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardActivitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardActivities>>> = ({ signal }) => getDashboardActivities(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardActivities>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardActivitiesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardActivities>>>
export type GetDashboardActivitiesInfiniteQueryError = unknown

/**
 * @summary 대시보드 활동 내역 조회
 */
export const useGetDashboardActivitiesInfinite = <TData = Awaited<ReturnType<typeof getDashboardActivities>>, TError = unknown>(
 params?: GetDashboardActivitiesParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardActivities>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardActivitiesInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDashboardActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardActivities>>, TError = unknown>(params?: GetDashboardActivitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardActivities>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardActivitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardActivities>>> = ({ signal }) => getDashboardActivities(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardActivities>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardActivities>>>
export type GetDashboardActivitiesQueryError = unknown

/**
 * @summary 대시보드 활동 내역 조회
 */
export const useGetDashboardActivities = <TData = Awaited<ReturnType<typeof getDashboardActivities>>, TError = unknown>(
 params?: GetDashboardActivitiesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardActivities>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardActivitiesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary 대시보드 통계 조회
 */
export const getDashboardStatistics = (
    params?: GetDashboardStatisticsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetDashboardStatistics200>(
      {url: `/api/v1/dashboard/statistics`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetDashboardStatisticsQueryKey = (params?: GetDashboardStatisticsParams,) => {
    return [`/api/v1/dashboard/statistics`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDashboardStatisticsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardStatistics>>, TError = unknown>(params?: GetDashboardStatisticsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardStatisticsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardStatistics>>> = ({ signal }) => getDashboardStatistics(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardStatisticsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardStatistics>>>
export type GetDashboardStatisticsInfiniteQueryError = unknown

/**
 * @summary 대시보드 통계 조회
 */
export const useGetDashboardStatisticsInfinite = <TData = Awaited<ReturnType<typeof getDashboardStatistics>>, TError = unknown>(
 params?: GetDashboardStatisticsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardStatisticsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDashboardStatisticsQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardStatistics>>, TError = unknown>(params?: GetDashboardStatisticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardStatisticsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardStatistics>>> = ({ signal }) => getDashboardStatistics(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardStatisticsQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardStatistics>>>
export type GetDashboardStatisticsQueryError = unknown

/**
 * @summary 대시보드 통계 조회
 */
export const useGetDashboardStatistics = <TData = Awaited<ReturnType<typeof getDashboardStatistics>>, TError = unknown>(
 params?: GetDashboardStatisticsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardStatistics>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardStatisticsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary 대시보드 요약 조회
 */
export const getDashboardSummary = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetDashboardSummary200>(
      {url: `/api/v1/dashboard/summary`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDashboardSummaryQueryKey = () => {
    return [`/api/v1/dashboard/summary`] as const;
    }

    
export const getGetDashboardSummaryInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) => getDashboardSummary(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardSummaryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSummary>>>
export type GetDashboardSummaryInfiniteQueryError = unknown

/**
 * @summary 대시보드 요약 조회
 */
export const useGetDashboardSummaryInfinite = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardSummaryInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) => getDashboardSummary(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSummary>>>
export type GetDashboardSummaryQueryError = unknown

/**
 * @summary 대시보드 요약 조회
 */
export const useGetDashboardSummary = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardSummaryQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary 대시보드 결제수단 정보 조회
 */
export const getDashboardPaymentMethods = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetDashboardPaymentMethods200>(
      {url: `/api/v1/dashboard/payment-methods`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDashboardPaymentMethodsQueryKey = () => {
    return [`/api/v1/dashboard/payment-methods`] as const;
    }

    
export const getGetDashboardPaymentMethodsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardPaymentMethods>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardPaymentMethods>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardPaymentMethodsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardPaymentMethods>>> = ({ signal }) => getDashboardPaymentMethods(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardPaymentMethods>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardPaymentMethodsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardPaymentMethods>>>
export type GetDashboardPaymentMethodsInfiniteQueryError = unknown

/**
 * @summary 대시보드 결제수단 정보 조회
 */
export const useGetDashboardPaymentMethodsInfinite = <TData = Awaited<ReturnType<typeof getDashboardPaymentMethods>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getDashboardPaymentMethods>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardPaymentMethodsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetDashboardPaymentMethodsQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardPaymentMethods>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardPaymentMethods>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardPaymentMethodsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardPaymentMethods>>> = ({ signal }) => getDashboardPaymentMethods(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardPaymentMethods>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardPaymentMethodsQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardPaymentMethods>>>
export type GetDashboardPaymentMethodsQueryError = unknown

/**
 * @summary 대시보드 결제수단 정보 조회
 */
export const useGetDashboardPaymentMethods = <TData = Awaited<ReturnType<typeof getDashboardPaymentMethods>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardPaymentMethods>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardPaymentMethodsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



